<template>
    <div class="report-footer px-5 pb-5">
        <hr class="mt-0" />
        <div class="columns">
            <div class="column is-9 has-text-left">
                <url-text :locale-key="'footer.text'"></url-text>
            </div>
            <div class="column is-3 has-text-right">{{ pageNumber || '' }}</div>
        </div>
    </div>
</template>

<script>
import UrlText from './UrlText.vue'

export default {
    components: {
        UrlText,
    },
    props: {
        pageNumber: {
            type: Number,
            default: null,
        },
    },
}
</script>
